import { Link } from 'react-router-dom';
import { Avatar } from '@/components/ui/Avatar';
import { Logo } from '@/components/ui/Logo';

/** 404 as a torn-off poster: the yellow field, a lost blob stuck over its edge, one way out. */
export function NotFound() {
  return (
    <div className="flex min-h-[100dvh] flex-col bg-ground" data-testid="not-found">
      <div className="relative bg-yellow text-night">
        <div className="mx-auto w-full max-w-content px-4 pb-20 pt-4 sm:px-6">
          <Link to="/" aria-label="Popin home" className="inline-flex rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-night">
            <Logo />
          </Link>
          <h1 className="mt-16 max-w-3xl font-display text-[48px] leading-[0.9] sm:text-[80px]">Nothing’s happening here.</h1>
        </div>
        <span className="absolute bottom-0 right-6 translate-y-1/2 rotate-[6deg] sm:right-16" aria-hidden>
          <Avatar avatar={{ hue: 220, shape: 'flower', face: 'chill' }} size={120} sticker />
        </span>
      </div>
      <div className="mx-auto w-full max-w-content px-4 pt-16 sm:px-6 sm:pt-12">
        <p className="max-w-sm text-[17px] text-muted">This page doesn’t exist, or it moved. Plenty is happening elsewhere though.</p>
        <Link to="/" className="mt-6 inline-flex h-12 items-center rounded-full bg-primary px-6 font-semibold text-ground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fg">
          Take me somewhere
        </Link>
      </div>
    </div>
  );
}
